





























import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
})
export default class TimeField extends Vue {
    value!: String
    required!: Boolean
    label!: String

    menu = false

    get _value() {
        return this.value
    }

    set _value(value) {
        this.$emit('input', value)
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TimeField.vue